var _rect, _path, _path2, _path3, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeTutorsClrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#FFF6F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5674 11.1504V16.8503C21.5674 17.7837 21.0674 18.6504 20.2591 19.1254L15.3091 21.9837C14.5008 22.4504 13.5008 22.4504 12.6841 21.9837L7.73411 19.1254C6.92578 18.6587 6.42578 17.792 6.42578 16.8503V11.1504C6.42578 10.217 6.92578 9.35032 7.73411 8.87532L12.6841 6.01699C13.4924 5.55033 14.4924 5.55033 15.3091 6.01699L20.2591 8.87532C21.0674 9.35032 21.5674 10.2087 21.5674 11.1504Z",
    stroke: "#FFAA78",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.0003 13.1665C15.0726 13.1665 15.9419 12.2972 15.9419 11.2248C15.9419 10.1525 15.0726 9.2832 14.0003 9.2832C12.9279 9.2832 12.0586 10.1525 12.0586 11.2248C12.0586 12.2972 12.9279 13.1665 14.0003 13.1665Z",
    stroke: "#FFAA78",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.3327 17.8836C17.3327 16.3836 15.841 15.167 13.9993 15.167C12.1577 15.167 10.666 16.3836 10.666 17.8836",
    stroke: "#FFAA78",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 3.5,
    stroke: "#FFAA78",
    strokeOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTutorsClrIcon);
export default __webpack_public_path__ + "static/media/home-tutors-clr-icon.48b2943b72c883e38932c9eeea583485.svg";
export { ForwardRef as ReactComponent };